import { Skeleton, SkeletonProps } from '@mui/material';

type SkeletonLoaderProps = SkeletonProps & {};

export function SkeletonLoader({ ...props }: SkeletonLoaderProps) {
  return <Skeleton {...props} />;
}
